// Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React from 'react'
import { Box, Typography, Link } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const Footer: React.FC = () => {
  const theme = useTheme()

  return (
    <Box
      data-testid="Footer"
      component="footer"
      sx={{
        py: 1.5,
        px: 2,
        backgroundColor: theme.palette.background.paper,
        borderTop: `1px solid ${theme.palette.divider}`,
        width: '100%',
        marginTop: '20px',
      }}
    >
      <Box
        data-testid="FooterInner"
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          maxWidth: '1200px',
          margin: '0 auto',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="caption" color="bodyMuted" sx={{ fontSize: '0.75rem' }}>
            Copyright Open Trade Technology Ltd. 2023-2025
          </Typography>
          <Typography variant="caption" color="bodyMuted" sx={{ fontSize: '0.75rem' }}>
            All rights reserved.
          </Typography>
        </Box>
        <Link
          href="https://docs.opentrade.io/stablecoin-yield/product-overview/legal/platform-terms-of-service"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: theme.palette.primary.main,
            textDecoration: 'none',
            fontSize: '0.75rem',
            '&:hover': {
              textDecoration: 'underline',
            },
          }}
        >
          Platform Terms of Service
        </Link>
      </Box>
    </Box>
  )
}

export default Footer
